import { SET_USER, SET_ERRORS, CLEAR_ERRORS, LOADING_UI, SET_UNAUTHENTICATED, LOADING_USER, SET_USER_HASH } from '../types'
import axios from 'axios'
import { FIREBASE_API_KEY } from '../../utilities/firebase'
import {
  FUNCTIONS_URL,
  STATE_FLAG,
} from '../../utilities/default-variables'

const FIREBASE_SIGNIN_URL = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${FIREBASE_API_KEY}`

export const signinUser = (userData, history) => async (dispatch) => {
  dispatch({ type: LOADING_UI })
  try {
    const { email, password } = userData
    const res = await axios.post(FIREBASE_SIGNIN_URL, {
      email,
      password,
      returnSecureToken: true,
    })
    setAuthorizationHeader(res.data.idToken)
    dispatch(getUserData())
    dispatch({ type: CLEAR_ERRORS })
    window.location = '/admin/orders'
  } catch (e) {
    const message = e.response && e.response.data && e.response.data.error
      ? e.response.data.error.message
      : e.message
    dispatch({
      type: SET_ERRORS,
      payload: { error: message }
    })
  }
}

export const signupUser = (newUserData, history) => async (dispatch) => {
  dispatch({ type: LOADING_UI })
  try {
    await axios.post(`${FUNCTIONS_URL[STATE_FLAG]}signup`, newUserData)
    // Server created the Firebase Auth user — now sign in to get the ID token
    const res = await axios.post(FIREBASE_SIGNIN_URL, {
      email: newUserData.email,
      password: newUserData.password,
      returnSecureToken: true,
    })
    setAuthorizationHeader(res.data.idToken)
    dispatch(getUserData())
    dispatch({ type: CLEAR_ERRORS })
    history.push('/')
  } catch (e) {
    dispatch({
      type: SET_ERRORS,
      payload: e.response ? e.response.data : { error: e.message }
    })
  }
}

export const signoutUser = () => (dispatch) => {
  localStorage.removeItem('FBIdToken')
  delete axios.defaults.headers.common['Authorization']
  dispatch({ type: SET_UNAUTHENTICATED })
}

export const getUserData = () => (dispatch) => {
  dispatch({ type: LOADING_USER })
  axios.get(`${FUNCTIONS_URL[STATE_FLAG]}getUserData`)
    .then(res => {
      dispatch({
        type: SET_USER,
        payload: res.data.data
      })
    })
    .catch(e => console.log(e))
}

export const assignHashToUser = (userHash) => (dispatch) => {
  dispatch({ type: LOADING_UI })
  dispatch({
    type: SET_USER_HASH,
    payload: userHash
  })
}

const setAuthorizationHeader = (token) => {
  const FBIdToken = `Bearer ${token}`
  localStorage.setItem('FBIdToken', FBIdToken)
  axios.defaults.headers.common['Authorization'] = FBIdToken
}
